import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  DashboardStafferScreenBreakdownRow,
  GoalPeriod,
  HttpResponse,
} from "@/types";

export function useGetDashboardStafferScreenBreakdown({
  userId,
  period,
  // Scopes the breakdown to one Saturday-Friday week; null uses the period.
  weekStart,
  enabled,
}: {
  userId: number | null;
  period: GoalPeriod;
  weekStart: string | null;
  enabled: boolean;
}) {
  return useQuery({
    queryKey: [
      "dashboard-staffer-screen-breakdown",
      userId,
      period,
      weekStart,
    ],
    queryFn: async () => {
      const weekParam = weekStart
        ? `&weekStart=${encodeURIComponent(weekStart)}`
        : "";
      const res = await guacHttpClient.get<
        DashboardStafferScreenBreakdownRow[],
        HttpResponse<DashboardStafferScreenBreakdownRow[]>
      >(
        `dashboard/staffer-stats/screen-breakdown?userId=${(userId ?? 0).toString()}&period=${period}${weekParam}`,
      );
      return res.data;
    },
    enabled: enabled && userId !== null,
  });
}
